// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddInvoiceMutation($input: AddInvoiceInput!) {
    addInvoice(input: $input) {
      invoiceEdge {
        node {
          id
          invoiceNumber
          status
          currency
          subtotal
          discountPercent
          discountAmount
          taxRate
          taxAmount
          totalAmount
          amountPaid
          amountDue
          partialPercent
          milestoneLabel
          issueDate
          dueDate
          notes
          terms
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'PaginatedInvoicesContainer_invoices',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'invoiceEdge',
        },
      ],
    });
  },
};
